import apiClient from './AxiosHttp'

const checkCart = () => {
    return apiClient.get(`/cart/check/`)
}

const getCartItems = () => {
    return apiClient.get(`/cart/items/`)
}

const addCartItem = (details) => {
    return apiClient.post(`/cart/item/add/`, details)
}

const removeCartItem = (details)=> {
    return apiClient.post(`/cart/item/remove/`, details)
}

const addDelivery = (details) => {
    return apiClient.post(`/cart/delivery/add/`, details)
}

const getUserDelivery = () => {
    return apiClient.post(`/cart/delivery/user/`)
}

const cartServices = {
    checkCart,
    getCartItems,
    addCartItem,
    removeCartItem,
    addDelivery,
    getUserDelivery,
}

export default cartServices